import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import hexOpacity from '@deprecated-ui/utils/hexOpacity';
import { ModalConfirm } from './styled';

interface ModalMaximumSizeProps {
  onCancel: () => void;
  [key: string]: any;
}

function ModalMaximumSize({
  onCancel,
  isLoading,
  ...props
}: ModalMaximumSizeProps) {
  return (
    <ModalConfirm
      onCancel={onCancel}
      centered
      closable={false}
      width={400}
      title={
        <Text
          size="20px"
          height="40px"
          family="bold"
          // @ts-expect-error
          pt="20px"
          pl="20px"
          pr="20px"
        >
          File too large
        </Text>
      }
      footer={
        // @ts-expect-error
        <Flex pb="20px" px="20px" justify="flex-end" align="flex-end">
          <Button
            key="confirm"
            type="primary"
            // @ts-expect-error
            padding="10px 30px"
            width="80px"
            height="40px"
            radius="4px"
            onClick={onCancel}
          >
            OK
          </Button>
        </Flex>
      }
      maskStyle={{ backgroundColor: `${color.black}${hexOpacity(80)}` }}
      {...props}
    >
      {/* @ts-expect-error */}
      <Text pt="10px" pb="20px" px="20px">
        File is too large and cannot be uploaded. The maximum size for each file
        is 2MB
      </Text>
    </ModalConfirm>
  );
}

export default ModalMaximumSize;
